import React from "react";
import { ReactComponent as ErrorSVG } from "./error.svg";
import "./error-indicator.scss";
const ErrorIndicator = ({ loc, errorCaptionKey, descriptionComponent, captionText }) => {
    return (
        <div className="error-indicator">
            <h3 className="state-indicator__header error-indicator__header">
                {captionText || loc(errorCaptionKey || "errors.commonError")}
            </h3>
            <div className="state-indicator__indicator-wrapper">
                <ErrorSVG />
            </div>
            {descriptionComponent}
        </div>
    );
};

export default ErrorIndicator;
